import React, { Component } from "react";
import {
  LoadingComponent,
  PageListComponent,
  HeaderListComponent,
  FormActionComponent,
  FormWrapperInputComponent,
  FormWrapperItem,
} from "../../../common/component/Index";
import { Button, Checkbox, DatePicker, Icon, InputNumber, Modal, Radio, Tooltip } from "antd";
import Input from "../../../common/component/Input";
import { isEqual, find, merge, max, cloneDeep } from "lodash";
import * as Func from "../../../../../helpers/functions";
import SupplierCategory from "../../../../../models/SupplierCategory";
import { DATE_TIME_FORMAT, DETAIL_ACTIONS, PATHS, TAG_GROUP_SITE_TYPE, TRANSLATE_LANGUAGE, FEATURE_FLAGS } from "../../../../../constants/Define";
import Wrapper from "../../../common/component/Wrapper";
import "./CategoryDetail.less";
import DualListBox from "react-dual-listbox";
import AntSelect, {
  AntOption,
} from "containers/backend/common/component/AntSelect";
import Span from "containers/backend/common/component/Span";
import VinwonderTagGroup from "models/VinWonderTagGroup";
import Translation from "models/Translation";
import AutoTranslate from "containers/backend/common/component/AutoTranslate/AutoTranslate";
import TranslateButton from "../../../common/component/TranslateButton";
import MessageValidation from "../../../common/MessageValidation";
import moment from "moment";

const defaultState = {
  action: "CREATE",
  validation: {},
};

const REPEAT_TYPES = {
  NONE: 0,
  WEEKLY: 1,
  MONTHLY: 2,
};

const WEEK_DAYS = [
  { value: 1, label: "T2" },
  { value: 2, label: "T3" },
  { value: 3, label: "T4" },
  { value: 4, label: "T5" },
  { value: 5, label: "T6" },
  { value: 6, label: "T7" },
  { value: 0, label: "CN" },
];

const MONTH_DAYS = Array.from({ length: 31 }, (_, index) => index + 1);
const DAY_OF_MONTH_TYPES = {
  LastDayOfMonth: 32,
  DoubleDayOfMonth: 33,
  LastFiveDaysOfMonth: 34,
};
const SPECIAL_DAYS_OF_MONTH = [
  DAY_OF_MONTH_TYPES.LastDayOfMonth,
  DAY_OF_MONTH_TYPES.DoubleDayOfMonth,
  DAY_OF_MONTH_TYPES.LastFiveDaysOfMonth,
];
const VALID_DAYS_OF_MONTH = [...MONTH_DAYS, ...SPECIAL_DAYS_OF_MONTH];
export default class SupplierCategoryVWDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...defaultState,
      vinwonderTagGroupDetail:
        this.props.vinwonderTagGroupState.vinwonderTagGroupDetail,
      isAllowEdit: false,
      supplierCategories: this.props.vinwonderTagGroupState.supplierCategories,
      listSkus: this.props.vinwonderTagGroupState.skusFollowSupplier,
      supplierSelectQuickFilter: "",
      skuSelected: [],
      isDelete: false,

    };
  }

  componentDidMount() {
    this.initDetail();
  }

  componentWillUnmount() {
    this.props.setVinwonderTagGroupDetail(new VinwonderTagGroup());
    this.props.setListSkusFollowSupplier([]);
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.vinwonderTagGroupState.vinwonderTagGroupDetail &&
      !isEqual(
        nextProps.vinwonderTagGroupState.vinwonderTagGroupDetail,
        this.props.vinwonderTagGroupState.vinwonderTagGroupDetail
      )
    ) {
      const vinwonderTagGroupDetail =
        nextProps.vinwonderTagGroupState.vinwonderTagGroupDetail;
      const supplierSelectQuickFilter =
        (vinwonderTagGroupDetail.suppliers || []).find(
          (item) =>
            item.supplierId ===
            this.state.supplierSelectQuickFilter?.supplierId
        ) || (vinwonderTagGroupDetail.suppliers || [])[0];

      this.setState({
        vinwonderTagGroupDetail,
        supplierSelectQuickFilter: supplierSelectQuickFilter || "",
        skuSelected: supplierSelectQuickFilter?.skuIds || [],
        action: vinwonderTagGroupDetail.id
          ? "UPDATE"
          : this.state.action,
      }, () => {
        if (supplierSelectQuickFilter?.supplierId) {
          this.props.getListSkusFollowSupplier(
            supplierSelectQuickFilter.supplierId
          );
        }
      });
    }
    if (
      nextProps.vinwonderTagGroupState.supplierCategories &&
      !isEqual(
        nextProps.vinwonderTagGroupState.supplierCategories,
        this.props.vinwonderTagGroupState.supplierCategories
      )
    ) {
      this.setState({
        supplierCategories: nextProps.vinwonderTagGroupState.supplierCategories,
      });
    }
    if (
      nextProps.vinwonderTagGroupState.skusFollowSupplier &&
      !isEqual(
        nextProps.vinwonderTagGroupState.skusFollowSupplier,
        this.props.vinwonderTagGroupState.skusFollowSupplier
      )
    ) {
      let listSkusSelected = [];
      const listSelected = (
        this.state.vinwonderTagGroupDetail?.suppliers || []
      ).find(
        (item) =>
          item.supplierId === this.state.supplierSelectQuickFilter.supplierId
      );
      listSkusSelected =
        nextProps.vinwonderTagGroupState.skusFollowSupplier.filter((item) =>
          (listSelected?.skuIds || []).includes(item.id)
        );
      this.setState({
        listSkus: nextProps.vinwonderTagGroupState.skusFollowSupplier,
        skuSelected: listSkusSelected,
      });
    }
  }

  getOperatingSchedule = () => {
    const operatingSchedule = this.state.vinwonderTagGroupDetail?.operatingSchedule || {};
    return {
      startDate: operatingSchedule.startDate,
      endDate: operatingSchedule.endDate,
      repeatType: Number(operatingSchedule.repeatType || REPEAT_TYPES.NONE),
      interval: operatingSchedule.interval || 1,
      daysOfWeek: Array.isArray(operatingSchedule.daysOfWeek) ? operatingSchedule.daysOfWeek : [],
      daysOfMonth: Array.isArray(operatingSchedule.daysOfMonth)
        ? operatingSchedule.daysOfMonth.map(Number)
        : [],
    };
  };

  getOperatingSchedulePayload = () => {
    const operatingSchedule = this.getOperatingSchedule();
    const repeatType = Number(operatingSchedule.repeatType);
    const payload = {
      startDate: operatingSchedule.startDate,
      endDate: operatingSchedule.endDate,
      repeatType,
      interval: Number(operatingSchedule.interval) || 1,
      daysOfWeek: null,
      daysOfMonth: null,
    };

    if (repeatType === REPEAT_TYPES.WEEKLY) {
      payload.daysOfWeek = operatingSchedule.daysOfWeek;
    }

    if (repeatType === REPEAT_TYPES.MONTHLY) {
      const daysOfMonth = operatingSchedule.daysOfMonth.filter((item) => VALID_DAYS_OF_MONTH.includes(item));
      payload.daysOfMonth = daysOfMonth.length
        ? daysOfMonth
        : null;
    }

    return payload;
  };

  onChangeOperatingSchedule = (value) => {
    this.setState({
      vinwonderTagGroupDetail: {
        ...this.state.vinwonderTagGroupDetail,
        operatingSchedule: {
          ...this.getOperatingSchedule(),
          ...value,
        },
      },
    });
  };

  onChangeOperatingScheduleDate = (field, date) => {
    const value = date ? `${date.format(DATE_TIME_FORMAT.SHORT_DATE_EXPORT)}T00:00:00` : undefined;
    const currentSchedule = this.getOperatingSchedule();
    const nextSchedule = { [field]: value };

    if (
      field === "startDate" &&
      value &&
      currentSchedule.endDate &&
      moment(currentSchedule.endDate).isBefore(moment(value), "day")
    ) {
      nextSchedule.endDate = undefined;
    }

    this.onChangeOperatingSchedule(nextSchedule);
  };

  onChangeRepeatType = (e) => {
    const repeatType = e.target.value;
    const currentSchedule = this.getOperatingSchedule();
    const nextSchedule = {
      repeatType,
      interval: currentSchedule.interval || 1,
    };

    if (repeatType === REPEAT_TYPES.NONE) {
      nextSchedule.daysOfWeek = [];
      nextSchedule.daysOfMonth = [];
    }

    if (repeatType === REPEAT_TYPES.WEEKLY) {
      nextSchedule.daysOfWeek = currentSchedule.daysOfWeek || [];
      nextSchedule.daysOfMonth = [];
    }

    if (repeatType === REPEAT_TYPES.MONTHLY) {
      nextSchedule.daysOfWeek = [];
      nextSchedule.daysOfMonth = currentSchedule.daysOfMonth || [];
    }

    this.onChangeOperatingSchedule(nextSchedule);
  };

  onToggleScheduleValue = (field, value) => {
    const currentValues = this.getOperatingSchedule()[field] || [];
    const nextValues = currentValues.includes(value)
      ? currentValues.filter((item) => item !== value)
      : [...currentValues, value];
    const orderedValues = field === "daysOfWeek"
      ? WEEK_DAYS.map((item) => item.value).filter((item) => nextValues.includes(item))
      : VALID_DAYS_OF_MONTH.filter((item) => nextValues.includes(item));

    this.onChangeOperatingSchedule({ [field]: orderedValues });
  };

  onSelectAllScheduleValues = (field, values) => {
    this.onChangeOperatingSchedule({ [field]: values });
  };

  formatOperatingScheduleDate = (date) => {
    return date ? moment(date).format(DATE_TIME_FORMAT.SHORT_DATE) : "__/__/____";
  };

  getOperatingScheduleSummary = () => {
    const operatingSchedule = this.getOperatingSchedule();
    const startDate = this.formatOperatingScheduleDate(operatingSchedule.startDate);
    const endDate = this.formatOperatingScheduleDate(operatingSchedule.endDate);
    const interval = Number(operatingSchedule.interval) || 1;

    if (operatingSchedule.repeatType === REPEAT_TYPES.NONE) {
      return `Không lặp lại từ ${startDate} đến ${endDate}.`;
    }

    if (operatingSchedule.repeatType === REPEAT_TYPES.WEEKLY) {
      const selectedDays = WEEK_DAYS
        .filter((item) => operatingSchedule.daysOfWeek.includes(item.value))
        .map((item) => item.label)
        .join(", ");
      const frequencyText = interval > 1 ? `lặp lại mỗi ${interval} tuần` : "lặp lại hàng tuần";

      return `Mỗi ${selectedDays || "ngày đã chọn"}, ${frequencyText} từ ${startDate} đến ${endDate}.`;
    }

    const selectedMonthDays = operatingSchedule.daysOfMonth
      .filter((item) => MONTH_DAYS.includes(item))
      .map((item) => `ngày ${item}`);
    if (operatingSchedule.daysOfMonth.includes(DAY_OF_MONTH_TYPES.LastDayOfMonth)) {
      selectedMonthDays.push("ngày cuối tháng");
    }
    if (operatingSchedule.daysOfMonth.includes(DAY_OF_MONTH_TYPES.DoubleDayOfMonth)) {
      selectedMonthDays.push("ngày đôi");
    }
    if (operatingSchedule.daysOfMonth.includes(DAY_OF_MONTH_TYPES.LastFiveDaysOfMonth)) {
      selectedMonthDays.push("5 ngày cuối tháng");
    }
    const frequencyText = interval > 1 ? `Mỗi ${interval} tháng` : "Mỗi tháng";

    return `${frequencyText} vào ${selectedMonthDays.join(" và ") || "ngày đã chọn"} từ ${startDate} đến ${endDate}.`;
  };

  renderScheduleOptionButton = (field, option) => {
    const selectedValues = this.getOperatingSchedule()[field] || [];
    const value = typeof option === "object" ? option.value : option;
    const label = typeof option === "object" ? option.label : option;

    return (
      <button
        key={value}
        type="button"
        className={`schedule-option-button ${selectedValues.includes(value) ? "active" : ""}`}
        onClick={() => this.onToggleScheduleValue(field, value)}
      >
        {label}
      </button>
    );
  };

  renderOperatingScheduleRepeatConfig = () => {
    const { validation } = this.state;
    const operatingSchedule = this.getOperatingSchedule();
    const repeatType = operatingSchedule.repeatType;

    if (repeatType === REPEAT_TYPES.NONE) {
      return null;
    }

    if (repeatType === REPEAT_TYPES.WEEKLY) {
      return (
        <div className={`operating-schedule-card ${(validation.operatingScheduleDays || validation.operatingScheduleInterval) ? "validate-failed" : ""}`}>
          <div className="operating-schedule-card-header">
            <div className="operating-schedule-card-title">
              Lặp lại vào các ngày
              <Tooltip title="Chọn các ngày trong tuần áp dụng bộ lọc">
                <Icon type="info-circle" className="ml-2" />
              </Tooltip>
            </div>
            <div className="operating-schedule-actions">
              <button type="button" onClick={() => this.onSelectAllScheduleValues("daysOfWeek", WEEK_DAYS.map((item) => item.value))}>
                Chọn tất cả
              </button>
              <span>|</span>
              <button type="button" onClick={() => this.onSelectAllScheduleValues("daysOfWeek", [])}>
                Bỏ chọn
              </button>
            </div>
            <div className="operating-schedule-frequency">
              <b>Tần suất</b>
              <span>Mỗi</span>
              <InputNumber
                min={1}
                value={operatingSchedule.interval}
                onChange={(value) => this.onChangeOperatingSchedule({ interval: value || 1 })}
              />
              <span>tuần</span>
            </div>
          </div>
          <MessageValidation
            validation={validation.operatingScheduleInterval}
            message={validation.operatingScheduleInterval?.messageError}
            className="d-block mt-2"
          />
          <div className="operating-schedule-options weekly-options">
            {WEEK_DAYS.map((item) => this.renderScheduleOptionButton("daysOfWeek", item))}
          </div>
          <MessageValidation
            validation={validation.operatingScheduleDays}
            message={validation.operatingScheduleDays?.messageError}
            className="d-block mt-2"
          />
        </div>
      );
    }

    return (
      <div className={`operating-schedule-card ${(validation.operatingScheduleDays || validation.operatingScheduleInterval) ? "validate-failed" : ""}`}>
        <div className="operating-schedule-card-header">
          <div className="operating-schedule-card-title">
            Lặp lại vào các ngày
            <Tooltip title="Chọn các ngày trong tháng áp dụng bộ lọc">
              <Icon type="info-circle" className="ml-2" />
            </Tooltip>
          </div>
          <div className="operating-schedule-frequency">
            <b>Tần suất</b>
            <span>Mỗi</span>
            <InputNumber
              min={1}
              value={operatingSchedule.interval}
              onChange={(value) => this.onChangeOperatingSchedule({ interval: value || 1 })}
            />
            <span>tháng</span>
          </div>
        </div>
        <MessageValidation
          validation={validation.operatingScheduleInterval}
          message={validation.operatingScheduleInterval?.messageError}
          className="d-block mt-2"
        />
        <div className="operating-schedule-month-type">
          <Radio checked>Theo ngày trong tháng</Radio>
          <div className="operating-schedule-actions">
            <button type="button" onClick={() => this.onSelectAllScheduleValues("daysOfMonth", MONTH_DAYS)}>
              Chọn tất cả
            </button>
            <span>|</span>
            <button type="button" onClick={() => this.onSelectAllScheduleValues("daysOfMonth", [])}>
              Bỏ chọn
            </button>
          </div>
        </div>
        <div className="operating-schedule-options monthly-options">
          {MONTH_DAYS.map((item) => this.renderScheduleOptionButton("daysOfMonth", item))}
        </div>
        <div className="operating-schedule-special-days">
          <Checkbox
            checked={operatingSchedule.daysOfMonth.includes(DAY_OF_MONTH_TYPES.LastDayOfMonth)}
            onChange={() => this.onToggleScheduleValue("daysOfMonth", DAY_OF_MONTH_TYPES.LastDayOfMonth)}
          >
            Ngày cuối tháng
          </Checkbox>
          <Checkbox
            checked={operatingSchedule.daysOfMonth.includes(DAY_OF_MONTH_TYPES.DoubleDayOfMonth)}
            onChange={() => this.onToggleScheduleValue("daysOfMonth", DAY_OF_MONTH_TYPES.DoubleDayOfMonth)}
          >
            Ngày đôi
          </Checkbox>
          <Checkbox
            checked={operatingSchedule.daysOfMonth.includes(DAY_OF_MONTH_TYPES.LastFiveDaysOfMonth)}
            onChange={() => this.onToggleScheduleValue("daysOfMonth", DAY_OF_MONTH_TYPES.LastFiveDaysOfMonth)}
          >
            5 ngày cuối tháng
          </Checkbox>
        </div>
        <MessageValidation
          validation={validation.operatingScheduleDays}
          message={validation.operatingScheduleDays?.messageError}
          className="d-block mt-2"
        />
      </div>
    );
  };

  renderOperatingScheduleSection = () => {
    const { validation } = this.state;
    const operatingSchedule = this.getOperatingSchedule();
    const disabledEndDate = (current) => {
      return current && operatingSchedule.startDate && current.isBefore(moment(operatingSchedule.startDate), "day");
    };

    return (
      <Wrapper className="row col-md-12">
        <Wrapper className="col-md-12">
          <div className="operating-schedule-section">
            <div className="operating-schedule-heading">
              <h4>Bộ lọc thời gian khả dụng</h4>
              <p>Thiết lập quy tắc thời gian và chu kỳ lặp lại cho các mục được lọc.</p>
            </div>
            <div className="operating-schedule-block">
              <div className="operating-schedule-label">Khoảng thời gian</div>
              <div className="row">
                <div className="col-md-6">
                  <div className={validation.operatingScheduleStartDate ? "validate-failed" : ""}>
                    <DatePicker
                      className="w100-percent operating-schedule-date-picker"
                      format={DATE_TIME_FORMAT.SHORT_DATE_EXPORT}
                      value={operatingSchedule.startDate ? moment(operatingSchedule.startDate) : null}
                      onChange={(date) => this.onChangeOperatingScheduleDate("startDate", date)}
                    />
                  </div>
                  <MessageValidation
                    validation={validation.operatingScheduleStartDate}
                    message={validation.operatingScheduleStartDate?.messageError}
                    className="d-block mt-1"
                  />
                </div>
                <div className="col-md-6">
                  <div className={validation.operatingScheduleEndDate ? "validate-failed" : ""}>
                    <DatePicker
                      className="w100-percent operating-schedule-date-picker"
                      format={DATE_TIME_FORMAT.SHORT_DATE_EXPORT}
                      value={operatingSchedule.endDate ? moment(operatingSchedule.endDate) : null}
                      disabledDate={disabledEndDate}
                      onChange={(date) => this.onChangeOperatingScheduleDate("endDate", date)}
                    />
                  </div>
                  <MessageValidation
                    validation={validation.operatingScheduleEndDate}
                    message={validation.operatingScheduleEndDate?.messageError}
                    className="d-block mt-1"
                  />
                </div>
              </div>
            </div>
            <div className="operating-schedule-block">
              <div className="operating-schedule-label">Tùy chọn lặp lại</div>
              <Radio.Group
                className="operating-schedule-repeat-types"
                value={operatingSchedule.repeatType}
                onChange={this.onChangeRepeatType}
              >
                <Radio value={REPEAT_TYPES.NONE}>Không lặp lại</Radio>
                <Radio value={REPEAT_TYPES.WEEKLY}>Hàng tuần</Radio>
                <Radio value={REPEAT_TYPES.MONTHLY}>Hàng tháng</Radio>
              </Radio.Group>
            </div>
            {this.renderOperatingScheduleRepeatConfig()}
            <div className="operating-schedule-summary">
              <Icon type="sync" />
              <div>
                <b>Tóm tắt quy tắc</b>
                <p>{this.getOperatingScheduleSummary()}</p>
              </div>
            </div>
          </div>
        </Wrapper>
      </Wrapper>
    );
  };

  render() {
    const { t } = this.props;
    const {
      action,
      validation,
      supplierCategories,
      vinwonderTagGroupDetail,
      supplierSelectQuickFilter,
      listSkus,
    } = this.state;
    return (
      <LoadingComponent spinning={false}>
        <PageListComponent>
          <HeaderListComponent
            path={this.props.match.path}
            groupPath={"supplierCategory"}
            titleHeader={
              action === "CREATE"
                ? Func.capitalizeFirstLetter(
                  `${t("action.create")} ${t(
                    "item.supplierCategory.title"
                  )}`.toLowerCase()
                )
                : Func.capitalizeFirstLetter(
                  `${t("action.update")} ${t(
                    "item.supplierCategory.title"
                  )}`.toLowerCase()
                )
            }
            componentRight={FEATURE_FLAGS.TRANSLATE_ENABLE &&
              <TranslateButton
                languages={vinwonderTagGroupDetail.translations}
                current={vinwonderTagGroupDetail.languageCode}
                validation={validation.languageCode}
                onChange={this.onShowTranslate}
                onClear={this.onExitTranslate}
                defaultSelecting={action === DETAIL_ACTIONS.CREATE}
                onSelectDefault={language => this.onChange("languageCode", language.code)}
                onRemove={this.onRemoveTranslate} />
            }
          />
          <Modal
            title=""
            visible={this.state.isDelete}
            onOk={() => {
              this.props.deleteVinWonder(vinwonderTagGroupDetail, {});
            }}
            onCancel={() => {
              this.setState({ isDelete: false });
            }}
          >
            <p>Xác nhận xóa nhóm sản phẩm VinWonders?</p>
          </Modal>
          <FormActionComponent
            onSubmit={this.onSubmit}
            isGetItem={false}
            action={action}
            onClickBack={this.onClickBack}
            activeComponent="switch"
            showActiveComponent={true}
            onChangeActive={(item) => {
              this.setState({
                vinwonderTagGroupDetail: {
                  ...vinwonderTagGroupDetail,
                  isActive: item.value,
                },
              });
            }}
            statusActive={this.state.vinwonderTagGroupDetail.isActive}
            submitButtonRight={true}
            additionalButton={
              Object.keys(this.props.match.params).length > 0 &&
                this.props.match.params.id ? (
                <Button
                  onClick={() => {
                    this.setState({ isDelete: true });
                  }}
                  className="btn btn-dark mr-2"
                >
                  Xóa
                </Button>
              ) : (
                <></>
              )
            }
          >
            <FormWrapperItem>
              <Wrapper className="row col-md-12">
                <Wrapper className="col-md-4">
                  <FormWrapperInputComponent
                    isRequired={false}
                    labelTitle={t(`item.vinwondertaggroup.nameVI`)}
                  >
                    <Input
                      type="text"
                      autoComplete="off"
                      placeholder={Func.capitalizeFirstLetter(
                        (
                          t("placeHolderForm.input") +
                          " " +
                          t("item.vinwondertaggroup.nameVI")
                        ).toLowerCase()
                      )}
                      className="form-control"
                      name="nameVI"
                      onChange={(e) =>
                        this.onChange("translations", {
                          langCode: TRANSLATE_LANGUAGE.VN.code,
                          text: e.target.value,
                        })
                      }
                      value={
                        (
                          this.state.vinwonderTagGroupDetail?.translations || []
                        ).find(
                          (item) =>
                            item.languageCode === TRANSLATE_LANGUAGE.VN.code
                        )?.name || ""
                      }
                    />
                  </FormWrapperInputComponent>
                </Wrapper>
                <Wrapper className="col-md-4">
                  <FormWrapperInputComponent
                    isRequired={true}
                    isValidation={true}
                    dataValidation={vinwonderTagGroupDetail.code}
                    validation={validation.code}
                    labelTitle={t(`item.vinwondertaggroup.code`)}
                  >
                    <Input
                      type="text"
                      autoComplete="off"
                      placeholder={Func.capitalizeFirstLetter(
                        (
                          t("placeHolderForm.input") +
                          " " +
                          t("item.vinwondertaggroup.code")
                        ).toLowerCase()
                      )}
                      className="form-control"
                      name="code"
                      onChange={(e) => this.onChange("code", e.target.value)}
                      value={this.state.vinwonderTagGroupDetail?.code || ""}
                    />
                  </FormWrapperInputComponent>
                </Wrapper>
                <Wrapper className="col-md-4">
                  <FormWrapperInputComponent
                    isRequired={false}
                    labelTitle={t(`item.vinwondertaggroup.nameEN`)}
                  >
                    <Input
                      type="text"
                      autoComplete="off"
                      placeholder={Func.capitalizeFirstLetter(
                        (
                          t("placeHolderForm.input") +
                          " " +
                          t("item.vinwondertaggroup.nameEN")
                        ).toLowerCase()
                      )}
                      className="form-control"
                      name="translation-name-en"
                      onChange={(e) =>
                        this.onChange("translations", {
                          langCode: TRANSLATE_LANGUAGE.EN.code,
                          text: e.target.value,
                        })
                      }
                      value={
                        (
                          this.state.vinwonderTagGroupDetail?.translations || []
                        ).find(
                          (item) =>
                            item.languageCode === TRANSLATE_LANGUAGE.EN.code
                        )?.name || ""
                      }
                    />
                  </FormWrapperInputComponent>
                </Wrapper>
                <Wrapper className="col-md-4">
                  <FormWrapperInputComponent
                    isRequired={false}
                    labelTitle={t(`item.vinwondertaggroup.nameKO`)}
                  >
                    <Input
                      type="text"
                      autoComplete="off"
                      placeholder={Func.capitalizeFirstLetter(
                        (
                          t("placeHolderForm.input") +
                          " " +
                          t("item.vinwondertaggroup.nameKO")
                        ).toLowerCase()
                      )}
                      className="form-control"
                      name="translation-name-ko"
                      onChange={(e) =>
                        this.onChange("translations", {
                          langCode: TRANSLATE_LANGUAGE.KO.code,
                          text: e.target.value,
                        })
                      }
                      value={
                        (
                          this.state.vinwonderTagGroupDetail?.translations || []
                        ).find(
                          (item) =>
                            item.languageCode === TRANSLATE_LANGUAGE.KO.code
                        )?.name || ""
                      }
                    />
                  </FormWrapperInputComponent>
                </Wrapper>
                <Wrapper className="col-md-4">
                  <FormWrapperInputComponent
                    isRequired={false}
                    labelTitle={t(`item.vinwondertaggroup.nameZh`)}
                  >
                    <Input
                      type="text"
                      autoComplete="off"
                      placeholder={Func.capitalizeFirstLetter(
                        (
                          t("placeHolderForm.input") +
                          " " +
                          t("item.vinwondertaggroup.nameZh")
                        ).toLowerCase()
                      )}
                      className="form-control"
                      name="translation-name-zh"
                      onChange={(e) =>
                        this.onChange("translations", {
                          langCode: TRANSLATE_LANGUAGE.ZH.code,
                          text: e.target.value,
                        })
                      }
                      value={
                        (
                          this.state.vinwonderTagGroupDetail?.translations || []
                        ).find(
                          (item) =>
                            item.languageCode === TRANSLATE_LANGUAGE.ZH.code
                        )?.name || ""
                      }
                    />
                  </FormWrapperInputComponent>
                </Wrapper>
                <Wrapper className="col-md-4">
                  <FormWrapperInputComponent
                    isRequired={false}
                    labelTitle={t(`item.vinwondertaggroup.nameRu`)}
                  >
                    <Input
                      type="text"
                      autoComplete="off"
                      placeholder={Func.capitalizeFirstLetter(
                        (
                          t("placeHolderForm.input") +
                          " " +
                          t("item.vinwondertaggroup.nameRu")
                        ).toLowerCase()
                      )}
                      className="form-control"
                      name="translation-name-ru"
                      onChange={(e) =>
                        this.onChange("translations", {
                          langCode: TRANSLATE_LANGUAGE.RU.code,
                          text: e.target.value,
                        })
                      }
                      value={
                        (
                          this.state.vinwonderTagGroupDetail?.translations || []
                        ).find(
                          (item) =>
                            item.languageCode === TRANSLATE_LANGUAGE.RU.code
                        )?.name || ""
                      }
                    />
                  </FormWrapperInputComponent>
                </Wrapper>
                <Wrapper className="col-md-12">
                  <MessageValidation
                    validation={validation.tabDisplayName}
                    message={validation.tabDisplayName?.messageError}
                    className="d-block"
                  />
                </Wrapper>
              </Wrapper>
              <Wrapper className="row col-md-12">
                <Wrapper className="col-md-12">
                  <FormWrapperInputComponent
                    isRequired={false}
                    isValidation={false}
                    labelTitle={t(`item.vinwondertaggroup.applyForSuppliers`)}
                  >
                    <AntSelect
                      className="select-tour-types tourTypes"
                      showArrow
                      mode="multiple"
                      placeholder={t(`item.tour.selectTourTypes`)}
                      value={(vinwonderTagGroupDetail?.suppliers || []).map(
                        (item) => item.supplierId
                      )}
                      onChange={this.onChangeSuppliers}
                      style={{ width: "100%" }}
                      filterOption={this.selectFilterSearchSupplier}
                      dropdownRender={this.renderMenuOption}
                      open={this.state.isOpen}
                      onDropdownVisibleChange={(isOpen) =>
                        this.setState({ isOpen })
                      }
                    >
                      {(supplierCategories || []).map((supplier) => (
                        <AntOption
                          key={supplier.id}
                          value={supplier.id}
                          data-name={supplier.name}
                        >
                          <Span
                            key={`span-${supplier.id}`}
                            className="select-tour-types-item"
                          >
                            {supplier.name} ({supplier.totalSkuConfiged} SKUs)
                          </Span>
                        </AntOption>
                      ))}
                    </AntSelect>
                  </FormWrapperInputComponent>
                </Wrapper>
              </Wrapper>
              <Wrapper className="row col-md-12">
                <Wrapper className="col-md-4">
                  <FormWrapperInputComponent
                    isRequired={false}
                    isValidation={true}
                    labelTitle={t(
                      `item.vinwondertaggroup.filterFollowSupplier`
                    )}
                  >
                    <AntSelect
                      className="select-departure"
                      showArrow
                      showSearch
                      placeholder={Func.capitalizeFirstLetter(
                        (
                          t("placeHolderForm.select") +
                          " " +
                          t("item.vinwondertaggroup.filterFollowSupplier")
                        ).toLowerCase()
                      )}
                      value={supplierSelectQuickFilter.supplierId}
                      onChange={this.onChangeQuickFilter}
                      style={{ width: "100%" }}
                      filterOption={this.selectFilterSearch}
                    >
                      {(supplierCategories || [])
                        .filter((i) =>
                          vinwonderTagGroupDetail.suppliers.find(
                            (item) => item.supplierId === i.id
                          )
                        )
                        .map((d) => (
                          <AntOption key={d.id} value={d.id}>
                            {d.name}
                          </AntOption>
                        ))}
                    </AntSelect>
                  </FormWrapperInputComponent>
                </Wrapper>
                <Wrapper className="col-md-4">
                  <FormWrapperInputComponent
                    isRequired={false}
                    isValidation={true}
                    labelTitle={t(`item.vinwondertaggroup.siteType`)}
                  >
                    <Radio.Group style={{ width: "100%" }}
                      options={[
                        {
                          label: "Product listing",
                          value: TAG_GROUP_SITE_TYPE.PRODUCT_LISTING,
                        },
                        {
                          label: "Microsite",
                          value: TAG_GROUP_SITE_TYPE.MICROSITE,
                        },
                      ]}
                      onChange={(value) => {
                        this.setState({
                          vinwonderTagGroupDetail: {
                            ...this.state.vinwonderTagGroupDetail,
                            siteType: value.target.value
                          }
                        })
                      }}
                      value={this.state.vinwonderTagGroupDetail.siteType}
                    />
                  </FormWrapperInputComponent>
                </Wrapper>
              </Wrapper>
              <Wrapper className="row col-md-12">
                <Wrapper className="col-md-12">
                  <DualListBox
                    canFilter
                    showHeaderLabels
                    filterPlaceholder={t("action.search")}
                    options={(listSkus || []).map((item) => ({
                      label: `${item.code} - ${item.name}`,
                      value: item.id,
                    }))}
                    selected={
                      this.state.vinwonderTagGroupDetail.suppliers.find(
                        (item) =>
                          item.supplierId ===
                          supplierSelectQuickFilter.supplierId
                      )?.skuIds || []
                    }
                    onChange={this.onChangeSkus}
                    filterCallback={this.onFilter}
                    lang={{
                      availableHeader: t("item.tagGroupDetails.skuAvailable"),
                      selectedHeader: t("item.tagGroupDetails.skuSelected"),
                    }}
                    icons={{
                      moveLeft: <Icon type="left" className="mx-2" />,
                      moveAllLeft: <Icon type="double-left" className="mx-2" />,
                      moveRight: <Icon type="right" className="mx-2" />,
                      moveAllRight: (
                        <Icon type="double-right" className="mx-2" />
                      ),
                    }}
                  />
                </Wrapper>
              </Wrapper>
              {this.renderOperatingScheduleSection()}

              {(action === DETAIL_ACTIONS.UPDATE) && (
                <AutoTranslate
                  className="wrapper-full supplier-category-VW"
                  languageCode={vinwonderTagGroupDetail?.languageCode || 'vi-VN'}
                  onChange={this.onChange}
                  targetLanguage={vinwonderTagGroupDetail?.targetLanguage}
                />
              )}
            </FormWrapperItem>
          </FormActionComponent>
        </PageListComponent>
      </LoadingComponent>
    );
  }

  initDetail() {
    const { match } = this.props;
    if (Object.keys(match.params).length > 0 && match.params.id) {
      const id = match.params.id;
      this.setState({ action: "UPDATE", isAllowEdit: true });
      this.props.getVinwonderTagGroupDetail(id);
      this.props.getListSuppliers({ tagGroupId: id });
    } else {
      this.props.getListSuppliers({});
    }
  }

  onChangeSkus = (selectedIds) => {
    const supliers = (this.state.vinwonderTagGroupDetail?.suppliers || []).map(
      (item) => {
        return {
          supplierId: item.supplierId,
          name: item.name,
          skuIds:
            item.supplierId === this.state.supplierSelectQuickFilter.supplierId
              ? selectedIds
              : item.skuIds,
          totalSkuConfiged: item.totalSkuConfiged || 0,
        };
      }
    );
    this.setState({
      skuSelected: selectedIds,
      vinwonderTagGroupDetail: {
        ...this.state.vinwonderTagGroupDetail,
        suppliers: supliers,
      },
    });
  };

  selectFilterSearch = (input, option) => {
    const identityCustomMutiple =
      option?.props?.children?.props?.children?.[0] || "";
    const optionText = Func.vietnameseStringToUnicode(
      identityCustomMutiple || (option?.props?.children || "")?.toLowerCase()
    );
    const inputText = Func.vietnameseStringToUnicode(input.toLowerCase());
    return optionText.indexOf(inputText) >= 0;
  };
  selectFilterSearchSupplier = (input, option) => {
    const name = option.props["data-name"] || "";
    const optionText = Func.vietnameseStringToUnicode(name.toLowerCase());
    const inputText = Func.vietnameseStringToUnicode(input.toLowerCase());

    return optionText.indexOf(inputText) >= 0;
  };

  onFilter = (option, filterInput) => {
    if (filterInput === "") {
      return true;
    }
    const optionText = Func.vietnameseStringToUnicode(
      option.label.toLowerCase()
    );
    const inputText = Func.vietnameseStringToUnicode(filterInput.toLowerCase());
    return (
      optionText.indexOf(inputText) >= 0 || optionText.indexOf(inputText) >= 0
    );
  };

  onChangeSuppliers = (ids) => {
    const { supplierCategories } = this.state;
    const suppliers = ids
      .map((id) => find(supplierCategories, (t) => t.id === id))
      .filter((i) => !!i);
    const supplierAfterMapping = suppliers.map((sp) => {
      const supplier = find(
        this.state.vinwonderTagGroupDetail.suppliers,
        (t) => t.supplierId === sp.id
      );
      if (supplier) {
        return supplier;
      }
      return {
        supplierId: sp.id,
        skuIds: [],
        totalSkuConfiged: sp.totalSkuConfiged || 0,
      };
    });
    this.setState({
      vinwonderTagGroupDetail: {
        ...this.state.vinwonderTagGroupDetail,
        suppliers: supplierAfterMapping,
      },
    });
  };

  onChangeQuickFilter = (id) => {
    this.props.getListSkusFollowSupplier(id);
    const supplierSelected = this.state.vinwonderTagGroupDetail.suppliers.find(
      (item) => item.supplierId === id
    );
    this.setState({
      supplierSelectQuickFilter: supplierSelected,
      skuSelected: supplierSelected?.skuIds || [],
    });
  };

  onChange = (key, value) => {
    switch (key) {
      case "translations":
        const replacementNameAttribute = (
          this.state.vinwonderTagGroupDetail?.translations || []
        ).find((item) => item.languageCode === value.langCode);
        const listNewTranslation = (
          this.state.vinwonderTagGroupDetail?.translations || []
        ).filter((item) => item.languageCode !== value.langCode);
        if (replacementNameAttribute) {
          listNewTranslation.push({
            ...replacementNameAttribute,
            name: value.text,
          });
        } else {
          listNewTranslation.push({
            languageCode: value.langCode,
            isDefault: true,
            name: value.text,
          });
        }
        this.setState({
          vinwonderTagGroupDetail: {
            ...this.state.vinwonderTagGroupDetail,
            translations: listNewTranslation,
          },
        });
        break;
      case "name":
        this.setState({
          vinwonderTagGroupDetail: {
            ...this.state.vinwonderTagGroupDetail,
            name: value,
          },
        });
        break;
      case "code":
        this.setState({
          vinwonderTagGroupDetail: {
            ...this.state.vinwonderTagGroupDetail,
            code: value,
          },
        });
        break;
      case "languageCode":
      case "targetLanguage":
        this.setState({
          vinwonderTagGroupDetail: {
            ...this.state.vinwonderTagGroupDetail,
            [key]: value,
          },
        });
        break;
      default:
        break;
    }
  };

  onShowTranslate = (language) => {
    const vinwonderTagGroupDetail = new VinwonderTagGroup(this.state.vinwonderTagGroupDetail);
    vinwonderTagGroupDetail.setTranslate(language.code);
    vinwonderTagGroupDetail.setData();
    this.setState({ vinwonderTagGroupDetail, action: DETAIL_ACTIONS.TRANSLATE });
  }

  onExitTranslate = () => {
    const vinwonderTagGroupDetail = new VinwonderTagGroup(this.state.vinwonderTagGroupDetail);
    const action = DETAIL_ACTIONS[vinwonderTagGroupDetail.id ? "UPDATE" : "CREATE"];
    vinwonderTagGroupDetail.setTranslate(undefined, true);
    vinwonderTagGroupDetail.setData();
    this.setState({ vinwonderTagGroupDetail, action });
  }

  onRemoveTranslate = (language) => {
    const vinwonderTagGroupDetail = new VinwonderTagGroup(this.state.vinwonderTagGroupDetail);
    const translations = vinwonderTagGroupDetail.translations || [];
    const hasLanguage = translations.some(item => item.languageCode === language.code);
    const updatedTranslations = translations.map(item =>
      item.languageCode === language.code
        ? new Translation({ ...item, name: vinwonderTagGroupDetail.name })
        : item
    );
    if (!hasLanguage) {
      updatedTranslations.push(new Translation({ languageCode: language.code, name: "" }));
    }
    vinwonderTagGroupDetail.translations = updatedTranslations;
    this.props.updateVinwonderTagGroupAction(vinwonderTagGroupDetail, {
      onSuccess: () => {
        this.props.getVinwonderTagGroupDetail(vinwonderTagGroupDetail.id);
      },
    });
  }

  onSaveTranslate = () => {
    const vinwonderTagGroupDetail = new VinwonderTagGroup(this.state.vinwonderTagGroupDetail);
    const currentLang = vinwonderTagGroupDetail.languageCode;
    const currentTranslation = (vinwonderTagGroupDetail.translations || []).find(
      item => item.languageCode === currentLang
    );
    vinwonderTagGroupDetail.name = currentTranslation?.name || vinwonderTagGroupDetail.name;
    const translateFunction = vinwonderTagGroupDetail.translate?.id
      ? this.props.updateVinwonderTagGroupTranslate
      : this.props.createVinwonderTagGroupTranslate;
    translateFunction(vinwonderTagGroupDetail);
    this.onExitTranslate();
  }

  onSubmit = (e) => {
    e.preventDefault();
    if (this.validate()) {
      const { action } = this.state;
      const vinwonderTagGroupDetail = new VinwonderTagGroup({
        ...this.state.vinwonderTagGroupDetail,
        operatingSchedule: this.getOperatingSchedulePayload(),
      });
      if (
        vinwonderTagGroupDetail.code.length <= 20 &&
        vinwonderTagGroupDetail.code.length >= 3
      ) {
        if (action === DETAIL_ACTIONS.TRANSLATE) {
          this.onSaveTranslate();
        } else if (action === "CREATE") {
          this.props.createVinwonderTagGroupAction(vinwonderTagGroupDetail);
        } else {
          this.props.updateVinwonderTagGroupAction(vinwonderTagGroupDetail, {
            onSuccess: () => {
              this.props.getVinwonderTagGroupDetail(vinwonderTagGroupDetail.id);
            }
          });
        }
      }
    }
  };

  onClickBack = () => {
    if (this.state.action === DETAIL_ACTIONS.TRANSLATE) {
      this.onExitTranslate();
    } else {
      this.props.history.push(PATHS.TAG_GROUP_VW.LIST.path);
    }
  };

  validate() {
    const { t } = this.props;
    let validate = {
      required: {
        code: Func.formatValidation(
          t("validation.statusCode.code.1"),
          t(`item.supplierCategory.code`)
        ),
      },
      minLength: { code: t("validation.minCodeVWTag") },
      maxLength: { code: t("validation.maxCodeVWTag") },
    };
    if (this.state.action === DETAIL_ACTIONS.CREATE) {
      validate.required.languageCode = Func.formatValidation(
        t("validation.statusCode.code.1"),
        t(`translate.defaultLanguage`)
      );
    }
    let valueValidate = {
      minLength: { code: 3 },
      maxLength: { code: 20 },
    };
    const tabDisplayNameLanguageCodes = [
      TRANSLATE_LANGUAGE.VN.code,
      TRANSLATE_LANGUAGE.EN.code,
      TRANSLATE_LANGUAGE.KO.code,
      TRANSLATE_LANGUAGE.ZH.code,
      TRANSLATE_LANGUAGE.RU.code,
    ];
    const hasTabDisplayName = (this.state.vinwonderTagGroupDetail.translations || []).some(
      (item) =>
        tabDisplayNameLanguageCodes.includes(item.languageCode) &&
        item.name &&
        item.name.trim()
    );
    const result = Func.multipleValidate(
      {
        code: this.state.vinwonderTagGroupDetail.code,
        languageCode: this.state.vinwonderTagGroupDetail?.languageCode || TRANSLATE_LANGUAGE.VN.code
      },
      validate,
      valueValidate
    );
    if (!hasTabDisplayName) {
      result.tabDisplayName = {
        classError: "hms-error-form",
        messageError: "Vui lòng nhập ít nhất một tên tab hiển thị",
      };
    }
    Object.assign(result, this.validateOperatingSchedule());
    this.setState({ validation: result });
    return Object.keys(result).length < 1;
  }

  validateOperatingSchedule() {
    const operatingSchedule = this.getOperatingSchedulePayload();
    const result = {};

    if (!operatingSchedule.startDate) {
      result.operatingScheduleStartDate = {
        classError: "hms-error-form",
        messageError: "Vui lòng chọn ngày bắt đầu",
      };
    }

    if (!operatingSchedule.endDate) {
      result.operatingScheduleEndDate = {
        classError: "hms-error-form",
        messageError: "Vui lòng chọn ngày kết thúc",
      };
    }

    if (
      operatingSchedule.startDate &&
      operatingSchedule.endDate &&
      moment(operatingSchedule.endDate).isBefore(moment(operatingSchedule.startDate), "day")
    ) {
      result.operatingScheduleEndDate = {
        classError: "hms-error-form",
        messageError: "Ngày kết thúc phải lớn hơn hoặc bằng ngày bắt đầu",
      };
    }

    if (!operatingSchedule.interval || Number(operatingSchedule.interval) < 1) {
      result.operatingScheduleInterval = {
        classError: "hms-error-form",
        messageError: "Tần suất phải lớn hơn 0",
      };
    }

    if (
      operatingSchedule.repeatType === REPEAT_TYPES.WEEKLY &&
      !(operatingSchedule.daysOfWeek || []).length
    ) {
      result.operatingScheduleDays = {
        classError: "hms-error-form",
        messageError: "Vui lòng chọn ít nhất một ngày trong tuần",
      };
    }

    if (
      operatingSchedule.repeatType === REPEAT_TYPES.MONTHLY &&
      !(operatingSchedule.daysOfMonth || []).length
    ) {
      result.operatingScheduleDays = {
        classError: "hms-error-form",
        messageError: "Vui lòng chọn ít nhất một ngày trong tháng",
      };
    }

    return result;
  }
}
